function JobCategoriesFinanceIcon({ color = "#191515" }) {
  return (
    <svg
      width="32"
      height="42"
      viewBox="0 0 32 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 25.2C11.0987 25.2 7.11111 22.0598 7.11111 18.2C7.11111 14.3402 11.0987 11.2 16 11.2C20.9013 11.2 24.8889 14.3402 24.8889 18.2C24.8889 19.7463 26.4807 21 28.4444 21C30.4082 21 32 19.7463 32 18.2C32 12.2148 26.6716 7.1946 19.5556 5.91745V2.8C19.5556 1.2537 17.9638 0 16 0C14.0362 0 12.4444 1.2537 12.4444 2.8V5.91745C5.32844 7.1946 0 12.2148 0 18.2C0 25.1477 7.17756 30.8 16 30.8C20.9013 30.8 24.8889 33.9402 24.8889 37.8C24.8889 41.6598 20.9013 44.8 16 44.8C11.0987 44.8 7.11111 41.6598 7.11111 37.8C7.11111 36.2537 5.51933 35 3.55556 35C1.59178 35 0 36.2537 0 37.8C0 43.7852 5.32844 48.8054 12.4444 50.0826V53.2C12.4444 54.7463 14.0362 56 16 56C17.9638 56 19.5556 54.7463 19.5556 53.2V50.0826C26.6716 48.8054 32 43.7852 32 37.8C32 30.8523 24.8224 25.2 16 25.2Z"
        fill={color}
      />
    </svg>
  );
}

export default JobCategoriesFinanceIcon;
